import Image from 'next/image';
import styled from 'styled-components';

const AvatarImageWrapper = styled.div`
  height: fit-content !important;
  width: 100% !important;
  margin: auto;
  span {
    position: relative !important;
    height: 100% !important;
    width: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const contentfulLoader = ({ src, width, quality }) => {
  return `${src}?w=${width}&q=${quality || 75}`;
};

const AvatarImage = (props) => {
  return (
    <AvatarImageWrapper>
      <Image loader={contentfulLoader} {...props} />
    </AvatarImageWrapper>
  );
};

export default function Avatar({ name, picture }) {
  return (
    <div className="flex items-center">
      <div className="relative w-10 h-10 mr-4">
        <AvatarImage
          src={picture.url}
          className="rounded-full"
          alt={name}
          layout="responsive"
          height={picture.height}
          width={picture.width}
        />
      </div>
      <div className="text-lg font-bold">{name}</div>
    </div>
  );
}
